import React, { Component } from 'react'
import GlobalSearchView from '../component/GlobalSearchView'
import { debounce } from '../../../Utils/Functions'

class GlobalSearch extends Component {
  state = {
    searchString: '',
    suggestions: [],
  }

  onChange = async (event, { newValue }) => {
    await this.setState({ searchString: newValue })
  }

  initSearch = debounce(async () => {
    const { searchString } = this.state
    if (searchString.length < 1) return
    const { searchRequestHandler } = this.props
    const searchRequestResult = await searchRequestHandler(searchString)
    await this.setState({ suggestions: searchRequestResult })
  }, 200)

  handleSuggestionsFetchRequested = async ({ value }) => {
    if (value && value.length > 0) {
      await this.initSearch()
    }
  }

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    })
  }

  onSuggestionSelected = (event, { suggestion }) => {
    this.props.onSuggestionSelected(suggestion)
    this.setState({ searchString: '', suggestions: [] })
  }

  render() {
    const { suggestions, searchString } = this.state
    const { style, placeholder, showButton } = this.props
    return (
      <GlobalSearchView
        style={style}
        placeholder={placeholder}
        showButton={showButton}
        onChange={this.onChange}
        inputValue={searchString}
        suggestions={suggestions}
        onSuggestionSelected={this.onSuggestionSelected}
        handleSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
      />
    )
  }
}
export default GlobalSearch
